import type { FC, ReactNode, PropsWithChildren } from 'react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../../i18n';
import { StyledErrorRefresh, StyledRefreshIcon } from './ErrorRefresh.styled';

const onClickRefresh = () => window.location.reload();

export const ErrorRefresh: FC<PropsWithChildren<{ message: string }>> = ({ message }) => {
  const { formatMessage } = useIntl();

  const strong = useCallback(
    (children: ReactNode) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-to-interactive-role
      <strong role="button" tabIndex={0} onClick={onClickRefresh}>
        {children}
      </strong>
    ),
    []
  );

  return (
    <StyledErrorRefresh>
      <StyledRefreshIcon color="secondary" size="lg" />
      {message}
      <div>{formatMessage(messages.pleaseRefresh, { strong })}</div>
    </StyledErrorRefresh>
  );
};
